// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__dar4C","filled":"Accordion_filled__jMu2Q","hasBorderBottom":"Accordion_hasBorderBottom__DRAe7","secondary":"Accordion_secondary__Pzd8R"};